export default __webpack_public_path__ + "static/media/Pill 1.f2d2856d.png";